'use client';
import { MultiServicePreset } from '@/types';

import { useConfig } from '@/app/contexts/ConfigContext';
import CustomLink from './CustomLink';
import LanguageSelection from './LanguageSelection';
import {
  checkUrlCountry,
  isFRAndAllopassInternetPlus,
  isMobileAppPortalHost,
} from '@/helpers';
import MenuBurger from '@/components/MenuBurger';
import Nav from '@/components/Nav';
import NavMultiFitnessYogaPilates from './NavMultiFitnessYogaPilates';
import NavMultiAstrologyMeditationLove from './NavMultiAstrologyMeditationLove';

export default function Header() {
  const { config } = useConfig();
  const isMobileAppPortal = isMobileAppPortalHost(
    config.SERVICE_URL_LINK,
  );

  return (
    <nav
      className={`z-20 2xl:h-[120px] h-20 px-3 2xl:px-[105px] bg-white flex flex-row gap-2 sm:gap-0 2xl:gap-14 justify-between shadow-lg ${
        isMobileAppPortal ? 'fixed inset-x-0 top-0 w-full' : 'relative'
      }`}
      style={{ backgroundColor: config.theme.backgroundColor }}
    >
      <div className='flex flex-row items-center gap-2 sm:gap-4 min-w-[320px] 2xl:min-w-[325px] min-h-[50px]'>
        <CustomLink href='/'>
          <img
            src={config.theme.logoSrc}
            className='2xl:h-12 h-10 object-contain'
            alt={`${config?.SERVICE_NAME} logo`}
            fetchPriority='high'
          />
        </CustomLink>
        <CustomLink href='/'>
          <span
            className='text-neutral-800 2xl:text-3xl text-[22.50px] font-extrabold ml-2.5 overflow-hidden whitespace-nowrap'
            style={{ color: config.theme.textColorDark }}
          >
            {config?.SERVICE_NAME}
          </span>
        </CustomLink>

        {/* Menu Burger (mobile) */}
        <MenuBurger />

        {/* Menu language (mobile) */}
        <div className='2xl:hidden absolute right-14 top-1/2 -translate-y-1/2'>
          <LanguageSelection />
        </div>
      </div>
      <div className='hidden 2xl:flex flex-row justify-between items-center w-full'>
        {/* Nav */}
        {config.multiService === MultiServicePreset.FYP ? (
          <NavMultiFitnessYogaPilates />
        ) : config.multiService === MultiServicePreset.AML ? (
          <NavMultiAstrologyMeditationLove />
        ) : (
          <Nav />
        )}

        <div className='flex items-center'>
          {(isFRAndAllopassInternetPlus(config.SERVICE_URL_LINK) ||
            checkUrlCountry(config.SERVICE_URL_LINK, 'testing')) && (
            <CustomLink href='/account'>
              <span
                className='text-neutral-800 min-w-[125px] text-xl flex justify-center font-bold'
                style={{ color: config.theme.textColorDark }}
              >
                Mon Compte
              </span>
            </CustomLink>
          )}

          {/* Menu language (desktop) */}
          <div className='ml-4'>
            <LanguageSelection />
          </div>
        </div>
      </div>
    </nav>
  );
}
